import React from 'react'

 function FormPageMaintenanceHeader({maintenanceHeader}) {
  return (
    <div className='item mt-4'>
        <h5>{maintenanceHeader} Bakım Bilgileri</h5>
    </div>
  )
}
export default FormPageMaintenanceHeader;